import { Box, Tab, Tabs, Paper } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { hasPermission } from 'store'
import 'utils/global.scss'

export const tabConfig = [
  {
    index: 0,
    label: 'Daily',
    path: 'daily',
    permission: 'attendance.admin',
  },
  {
    index: 1,
    label: 'Student',
    path: 'student',
    permission: 'attendance.admin',
  },
  {
    index: 2,
    label: 'Teacher',
    path: 'teacher',
    permission: 'attendance.teacher',
  },
  {
    index: 3,
    label: 'Settings',
    path: 'settings',
    permission: 'attendance.settings',
  },
]

export default function SchedulingTabs() {
  const { t } = useTranslation()
  const theme = useSelector(state => state.session.appearance)
  const { '*': tabName } = useParams()
  const permittedTabs = tabConfig.filter(tab => hasPermission(tab.permission));

  const getTabIndex = path => {
    const [tabName] = path.split("/");
    const found = permittedTabs.find(tab => tab.path === tabName);
    return found ? found.index : permittedTabs[0]?.index ?? 0;
  };
  const [tabIndex, setTabIndex] = useState(getTabIndex(tabName))

  useEffect(() => {
    setTabIndex(getTabIndex(tabName));
  }, [tabName, permittedTabs.length]);

  const basePath = `/attendance`

  return (
    <Paper sx={{ width: '100%', py: 1, px: 2, mb: 1 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', displayPrint: 'none' }}>
        <Tabs value={tabIndex}>
          {permittedTabs.map(tab => (
            <Tab
              key={tab.path}
              sx={{ color: tabIndex === tab.index && "primary !important" }}
              className={tabIndex === tab.index
                ? `tab-item-selected`
                : `tab-item-${theme}`
              }
              label={t(tab.label)}
              value={tab.index}
              component={Link}
              to={`${basePath}/${tab.path}`}
              disabled={tab.disabled}
            />
          ))}
        </Tabs>
      </Box>
    </Paper>
  )
}
